import { useState, useMemo, useCallback, useEffect } from 'react';
import type { ContentFolder } from 'services/folders/entities';
import { ROOT_ID, findFolderById, getBreadcrumbs } from './folderNavigation';

export function useFolderNavigation(rootFolder: ContentFolder, rootLabel: string) {
  const [currentFolderId, setCurrentFolderId] = useState(ROOT_ID);

  useEffect(() => {
    setCurrentFolderId(ROOT_ID);
  }, [rootFolder]);

  const currentFolder = useMemo(() => {
    return findFolderById(rootFolder, currentFolderId) ?? rootFolder;
  }, [rootFolder, currentFolderId]);

  const breadcrumbs = useMemo(() => getBreadcrumbs(rootFolder, currentFolderId, rootLabel), [rootFolder, currentFolderId, rootLabel]);

  const selectFolder = useCallback((id: string) => {
    setCurrentFolderId(id);
  }, []);

  return {
    breadcrumbs,
    currentFolder,
    selectFolder,
  };
}
